export default __webpack_public_path__ + "static/media/mena6.01a6b594.PNG";